exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-paading {\n  padding-left: 0;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.underline-h1 {\n  text-decoration: underline;\n}\n\n.bold {\n  font-weight: 700;\n}\n", ""]);

// exports
